import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link } from '@material-ui/core';
import {  VERSION  } from '../../../../constants'; 

const useStyles = makeStyles(theme => ({
    root: {
        padding: '64px 16px',
        marginBottom: 12,
        textAlign: 'center',
        borderTop: '1px solid #567934',
        background: '#67b1e2',
        color: "white",
        fontSize: 18,
      },
      section: {
          marginBottom: 18,
      },
      companyName: {
          fontSize: 28,
          marginBottom: 2,
      },
      companyAddress: {
        lineHeight: '26px',
      },
      version: {
          color: "#4192bd",
          float: 'right',
          margin: 18,
          fontSize: 12,
      }
}));

const Footer = props => {
    const { className, ...rest } = props;

    const classes = useStyles();

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
        <p className={classes.section}>
          <div className={classes.companyName}>Understanding Ag, LLC</div>
          <div className={classes.companyAddress}>
            1908 Spring Drive NW<br />
            Fort Payne AL 35968<br />
          </div>
        {/* <a href="https://soilhealthacademy.org/contact-us"  target="_blank" className='brand-link'>Contact Us</a>   */}
        
               <a href={`mailto: support@regenagonline.com`}  target="_blank" className='brand-link'>support@regenagonline.com</a>  

    </p>
            <p className={classes.section}>
                Copyright &copy;{` ${new Date().getFullYear()}`}  Understanding Ag, LLC
    </p>
            <p className={classes.section}>
                All website content is the property of Understanding Ag, LLC.  No one can duplicate or use our materials without express written consent from Understanding Ag, LLC.
    </p>
            <p className={classes.section}>
                Understanding Ag admits students of any race, color, gender and ethnic origin to all the rights, privileges, programs and activities generally accorded or made available to students at the school. It does not discriminate on the basis of race, color, gender and ethnic origin in the administration of its educational policies, admission policies, and other school administered programs.
    </p>
    <p className={classes.section} style={{fontSize: 12, margin:48}}>
            <a href="/terms-and-conditions" target="terms" style={{marginRight: 48}} className='brand-link'>
                      Terms and Conditions
                    </a>
                Powered by&nbsp;
                <a  href="https://www.activmedia.works/" target="_blank" className='brand-link'>ActivMedia</a>  

            </p>
          <div className={`${classes.version}`}>{VERSION}</div>
        </div >
    );
};

Footer.propTypes = {
    className: PropTypes.string
};

export default Footer;
